<template>
  <div class="team-roster-page">
    <div v-if="pageLoading" class="state-tip">
      <van-loading size="24px" vertical>加载中...</van-loading>
    </div>
    <template v-else-if="loadError">
      <div class="state-tip">
        <van-empty description="缺少组别或球队参数" />
      </div>
    </template>
    <template v-else>
      <header class="team-header">
        <img
          v-if="teamBadgeUrl"
          class="team-header__badge"
          :src="teamBadgeUrl"
          alt=""
        >
        <!-- <div v-else class="team-header__badge team-header__badge--placeholder" /> -->
        <div class="team-header__info">
          <h1 class="team-header__name">{{ team.name || '—' }}</h1>
          <p v-if="leaderText" class="team-header__staff">领队：{{ leaderText }}</p>
          <p v-if="coachText" class="team-header__staff">教练：{{ coachText }}</p>
        </div>
      </header>

      <section class="roster-section">
        <h2 class="roster-section__title">球员名单</h2>
        <div v-if="players.length" class="player-list">
          <div
            v-for="item in players"
            :key="item.id"
            class="player-card"
          >
            <div class="player-card__avatar-wrap" v-if="item.photo">
              <img
                class="player-card__avatar"
                :src="photoUrl(item.photo)"
                alt=""
              >
            </div>
            <div class="player-card__body">
              <div class="player-card__name">{{ item.trueName || '—' }}</div>
              <div v-if="playerMetaLine(item)" class="player-card__meta">{{ playerMetaLine(item) }}</div>
            </div>
          </div>
        </div>
        <div v-else class="player-list-empty">
          <van-empty description="暂无球员数据" />
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import { Loading, Empty } from 'vant'
Vue.use(Loading).use(Empty)
import { getBMPlayerList, getBMUnionMatch } from '@/api/match'
import { QNImageUtil } from '@/utils'

export default {
  data() {
    return {
      matchId: '',
      teamId: '',
      pageLoading: false,
      loadError: false,
      team: {},
      players: [],
      leaderText: '',
      coachText: '',
      unionMatchId: ''
    }
  },
  computed: {
    teamBadgeUrl() {
      const b = this.team && this.team.badge || this.matchIcon
      if (!b || !String(b).trim()) return ''
      return QNImageUtil.imageView(String(b), 112, 112)
    }
  },
  created() {
    this.unionMatchId = this.$route.params.unionMatchId
    this.matchId = this.$route.query.matchId
    this.teamId = this.$route.query.teamId
    if (!this.matchId || !this.teamId) {
      this.loadError = true
      return
    }
    this.fetchPlayerList()
    this.getBMUnionMatch()
  },
  methods: {
    getBMUnionMatch() {
      if (!this.unionMatchId) return
      getBMUnionMatch({ unionMatchId: this.unionMatchId }).then(res => {
        if (res) {
          this.matchIcon = res.data.match.icon
        }
      })
    },
    photoUrl(key) {
      if (!key || !String(key).trim()) return ''
      return QNImageUtil.imageView(String(key), 96, 96)
    },
    playerMetaLine(item) {
      const parts = []
      if (item.number != null && item.number !== '' && Number(item.number) >= 0) {
        parts.push(`#${item.number}`)
      }
      if (item.position) {
        parts.push(String(item.position))
      }
      return parts.join(' ')
    },
    fetchPlayerList() {
      this.pageLoading = true
      this.loadError = false
      getBMPlayerList({
        teamId: this.teamId,
        matchId: this.matchId
      })
        .then(res => {
          if (res === false) {
            this.players = []
            this.team = {}
            this.leaderText = ''
            this.coachText = ''
            return
          }
          const data = (res && res.data) || {}
          this.players = Array.isArray(data.players) ? data.players : []
          this.team = data.team || {}
          const officers = data.offices || []
          const ls = []
          const cs = []
          officers.forEach(o => {
            if (o.role === '领队') {
              ls.push(o.trueName)
            } else if (o.role === '教练' || o.role === '主教练') {
              cs.push(o.trueName)
            }
          })
          this.leaderText = ls.join('、')
          this.coachText = cs.join('、')
        })
        .catch(() => {
          this.players = []
          this.team = {}
          this.leaderText = ''
          this.coachText = ''
        })
        .finally(() => {
          this.pageLoading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.team-roster-page {
  min-height: 100vh;
  box-sizing: border-box;
  background: #fff;
  padding-bottom: 24px;
}

.state-tip {
  padding: 80px 24px 40px;
  text-align: center;
}

.team-header {
  display: flex;
  align-items: flex-start;
  padding: 16px 16px 14px;
  background: #fff;
}

.team-header__badge {
  width: 70px;
  height: 70px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
  margin-right: 12px;
}

.team-header__badge--placeholder {
  background: #ebedf0;
}

.team-header__info {
  flex: 1;
  min-width: 0;
}

.team-header__name {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  line-height: 26px;
}

.team-header__staff {
  margin: 0 0 4px;
  font-size: 13px;
  color: #909399;
  line-height: 20px;
}

.team-header__staff:last-child {
  margin-bottom: 0;
}

.roster-section {
  margin-top: 4px;
}

.roster-section__title {
  margin: 0;
  padding: 12px 16px 10px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  background: #fff;
}

.player-list {
  padding: 0 16px;
  display: flex;
  flex-direction: column;

  > * + * {
    margin-top: 10px;
  }
}

.player-card {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  background: #f9f9f9;
  border-radius: 10px;
  box-sizing: border-box;
}

.player-card__avatar-wrap {
  flex-shrink: 0;
  margin-right: 12px;
}

.player-card__avatar {
  width: 48px;
  height: 48px;
  border-radius: 6px;
  object-fit: cover;
  display: block;
  background: #ebedf0;
}

.player-card__avatar--placeholder {
  background: #e4e7ed;
}

.player-card__body {
  flex: 1;
  min-width: 0;
}

.player-card__name {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  line-height: 22px;
  margin-bottom: 4px;
}

.player-card__meta {
  font-size: 13px;
  color: #909399;
  line-height: 18px;
}

.player-list-empty {
  padding: 24px 16px 8px;
}
</style>
